module.exports = __webpack_public_path__ + "static/media/alex.be746436.png";